import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/games/accents/free.png'
import _imports_1 from '@/assets/games/accents/windows.png'
import _imports_2 from '@/assets/games/accents/zip.png'


const _withScopeId = n => (_pushScopeId("data-v-4f16cabd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "games" }
const _hoisted_2 = { class: "games-body" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-title-iso" }, "Lil Robot Adventure: Watch my latest devlog", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "devlogs" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    type: "text/html",
    class: "youtube-iframe",
    src: "https://www.youtube.com/embed/gvNS0WNLFos?autoplay=0&origin=http://cosborn.org",
    frameborder: "0"
  }, "\n        "),
  /*#__PURE__*/_createElementVNode("div", { class: "page-subtitle" }, [
    /*#__PURE__*/_createTextVNode(" For more updates, subscribe to my YouTube channel "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.youtube.com/@cosborn",
      rel: "noopener",
      class: "link-external-page"
    }, "@cosborn")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<hr data-v-4f16cabd><div class=\"page-title\" data-v-4f16cabd>Download all of my 2D game demos for <img class=\"accent-free\" alt=\"free\" src=\"" + _imports_0 + "\" width=\"170\" height=\"24\" data-v-4f16cabd></div><div class=\"page-subtitle\" data-v-4f16cabd><div class=\"os-text\" data-v-4f16cabd> Games playable only on <img class=\"accent-windows\" alt=\"windows logo\" src=\"" + _imports_1 + "\" height=\"30\" data-v-4f16cabd></div><div data-v-4f16cabd><img class=\"accent-windows\" alt=\"windows logo\" src=\"" + _imports_2 + "\" width=\"40\" height=\"30\" data-v-4f16cabd> Download the ZIP <a href=\"https://drive.google.com/file/d/1AWFKZ-RiOxKOnqTX0JFjT-atnfQpM-is/view?usp=sharing\" rel=\"noopener\" class=\"link-external-page\" data-v-4f16cabd>here</a>! </div></div>", 3)
const _hoisted_8 = { class: "games-content" }

import GameCard from '@/components/GameCard.vue'
import games from '@/assets/games/games.json'

export default /*#__PURE__*/_defineComponent({
  __name: 'GamesView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(games).data, (game, n) => {
          return (_openBlock(), _createBlock(GameCard, {
            key: n,
            game: game,
            left: n%2 === 0
          }, null, 8, ["game", "left"]))
        }), 128))
      ])
    ])
  ]))
}
}

})